<div class="md-form md-outline">
  <input
    mdbInput
    type="text"
    class="form-control"
    [class.invalid]="control && control.invalid && (control.dirty || control.touched)"
    [formControl]="_control"
    [id]="id"
    [placeholder]="placeholder"
    [mdbValidate]="true"
    [validateSuccess]="false"
    (keypress)="checkValue($event)"
    (blur)="formatTextValue()"
    [min]="min"
    [max]="max"
    [name]="id"
    jhiMarkAsterisk
  />
  <label [for]="id">{{ label }}</label>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
    <span *ngIf="control.hasError('min')" jhiTranslate="components.inputs.errors.minNumber" [translateValues]="{ min: control.errors?.['min']?.min }"></span>
    <span *ngIf="control.hasError('max')" jhiTranslate="components.inputs.errors.maxNumber" [translateValues]="{ max: control.errors?.['max']?.max }"></span>
  </mdb-error>
</div>
